import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import { Text } from '@atlaskit/primitives/compiled';

import type { Snippet } from '../types/snippet.ts';
import {
	formatInsertCount,
	shouldShowInsertCount,
	shouldShowPrivateLabel,
} from '../utils/insertCountUtils.ts';
import { snippetUsageMessages } from './snippetUsage.i18n.ts';

export const SnippetUsageAndPrivateLabels = ({ snippet }: { snippet: Snippet }) => {
	const intl = useIntl();
	const showUsage = shouldShowInsertCount(snippet);
	const showPrivate = shouldShowPrivateLabel(snippet);

	if (!showUsage && !showPrivate) {
		return null;
	}

	return (
		<>
			{showUsage && (
				<Text size="small" color="color.text.subtle">
					{intl.formatMessage(snippetUsageMessages.snippetUses, {
						formattedCount: formatInsertCount(snippet.insertCount!),
						count: snippet.insertCount!,
					})}
				</Text>
			)}
			{showPrivate && (
				<Text size="small" color="color.text.subtle">
					<FormattedMessage {...snippetUsageMessages.privateLabel} />
				</Text>
			)}
		</>
	);
};
